import { EMediaType } from '@umu/umu-types';
import Uploader from "../../services/uploader/uploader";
import {
	IEncodeResult,
	IUpload,
	BinaryProgressData,
	UPLOAD_RESULT,
	IFailedRecordColumn,
} from './interface';
import { flatColumns } from 'common/src/components/customTable/util';


export function upload({ blob, ext, fileName }: IEncodeResult, userId: string): Promise<IUpload> {
	try {
		return Uploader(blob, {
			fileExt: ext,
			mediaType: EMediaType.IMAGE,
			teacherId: userId,
			fileName,
		}).then((payloadData) => {
			return {
				resourceId: payloadData.resource_id,
				url: payloadData.path,
				fileSize: blob.size,
			};
		});
	} catch (e) {
		throw e;
	}
}
export async function encode(file: File): Promise<IEncodeResult> {
	return new Promise<any>(async (resolve, _reject) => {
		const result: Blob = file;
		const fileExt = (file.name.split(/\./g).pop() || '').toLocaleLowerCase();
		const compressedFile = {
			blob: result,
			ext: fileExt,
			fileName: file.name,
		};
		const timer = setTimeout(() => {
			resolve(compressedFile);
		}, 5000);
		clearTimeout(timer);
		compressedFile.blob = result;
		resolve(compressedFile);
	});
}



export const formatFailedRecordsData = (list: any, columns: any, isCanMultistep?: boolean) => {
	const columnsNew = isCanMultistep ? flatColumns(columns) : columns;
	const columnKeys = columnsNew.map((item: any) => item.dataIndex);
	return list.map((item: any) => {
		const data = item.data || item;
		const newColumnData: IFailedRecordColumn = {};
		columnKeys.forEach((key: any, index: any) => {
			newColumnData[key] = data[index] || data[key];
		});
		return newColumnData;
	});
};


export const handleUploadProgressObj = (res: any) => {
	const result = {
		success: 0,
		failed: 0,
		total: 0
	}
	if (!res.data) {
		return result;
	}

	return {
		success: res.data.success || res.data.processed_lines || result.success,
		failed: res.data.failed || result.failed,
		total: res.data.total || res.data.total_lines || result.total
	};
}

export const handleUploadProgressNum = (progressData: BinaryProgressData) => {
	return (Number(progressData.success) + Number(progressData.failed)) / (Number(progressData.total));
}

export const handleUploadProgressStatus = (res: any) => {
	let { data: { is_finish, status } } = res;
	const obj = handleUploadProgressObj(res);
	const num = handleUploadProgressNum(obj);

	if (!status) {
		const { success, failed } = obj;
		if (num === 1 || Number(is_finish) === 1) {
			if (success > 0 && failed == 0) {
				status = UPLOAD_RESULT.SUCCESS_COMPLETE
			} else {
				status = UPLOAD_RESULT.ERROR_COMPLETE
			}
		} else {
			status = UPLOAD_RESULT.IN_PROGRESS;
		}
	}

	return {
		obj,
		num,
		status,
	}
}